import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  handleReload = () => {
    try {
      this.setState({ hasError: false, error: null });
    } catch (_) {}
    try {
      window.location.reload();
    } catch (_) {}
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="min-h-screen bg-[#FFFBF7] flex items-center justify-center px-4"
          data-testid="error-boundary-screen"
        >
          <div className="w-full max-w-sm bg-white border-2 border-[#1C1917] shadow-[6px_6px_0px_#1C1917] rounded-xl p-6 text-center">
            <div className="w-14 h-14 bg-[#FEE2E2] border-2 border-[#1C1917] rounded-xl flex items-center justify-center mx-auto mb-4 shadow-[2px_2px_0px_#1C1917]">
              <span className="text-2xl">⚠️</span>
            </div>
            <h2
              className="text-xl font-black text-[#1C1917] mb-2"
              style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
            >
              Ops, algo deu errado
            </h2>
            <p className="text-sm text-[#78716C] mb-5">
              Tivemos um problema ao carregar essa tela. Tente recarregar e se o
              erro persistir, limpe o cache do navegador.
            </p>
            <button
              onClick={this.handleReload}
              className="w-full bg-[#FF6B6B] text-white border-2 border-[#1C1917] shadow-[4px_4px_0px_#1C1917] rounded-full font-bold py-3 hover:translate-y-[2px] hover:shadow-[2px_2px_0px_#1C1917] transition-all active:translate-y-[4px] active:shadow-none"
              data-testid="error-boundary-reload-btn"
            >
              Recarregar
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
